<div class="container vehicle-information-page">
  <div class="container-header">
    <span class="title">{{ 'TRANSLATE.VEHICLE.INFORMATION' | translate }}</span>
  </div>

  <div class="container-body">
    @if (vinValidate) {
    <div class="vehicle-info-wrapper">
      <section class="vehicle-layout" aria-label="Vehicle information summary">
        <article class="vehicle-hero-card" aria-label="Vehicle model highlight">
          <img class="image-car" src="./../../../assets/image/vin/car.png" alt="">
          <h4 class="label-name-car">{{ vinValidate.modelName }}</h4>
        </article>

        <article class="vehicle-details-card" aria-label="Vehicle details">
          <div class="vehicle-info-content">
            <div class="vehicle-info-item vehicle-info-item--chassi">
              <span class="info-label">{{ 'TRANSLATE.TWO.POINTS.CHASSI.NUMBER' | translate }}</span>
              <span class="info-value monospace">{{ vinValidate.vin }}</span>
            </div>

            <div class="vehicle-info-item vehicle-info-item--warranty">
              <span class="info-label">{{ 'TRANSLATE.TWO.POINTS.WARRANTY' | translate }}</span>
              <div class="warranty-date-wrapper"
                [ngClass]="{ 'show-date': vinValidate.warrantyStartDate === null, 'hide-date': vinValidate.warrantyStartDate !== null }">
                <span class="info-value info-value--warranty">{{ newDate() }}</span>
              </div>
            </div>

            <div class="vehicle-info-item">
              <span class="info-label">{{ 'TRANSLATE.TWO.POINTS.MODEL' | translate }}</span>
              <span class="info-value">{{ vinValidate.modelName }}</span>
            </div>

            <div class="vehicle-info-item">
              <span class="info-label">{{ 'TRANSLATE.TWO.POINTS.NEW' | translate }}</span>
              <span class="info-value">{{ validationKm }}</span>
            </div>

            <div class="vehicle-info-item">
              <span class="info-label">{{ 'TRANSLATE.TWO.POINTS.MODEL.YEAR' | translate }}</span>
              <span class="info-value">{{ vinValidate.modelYear }}</span>
            </div>
          </div>

          <div class="odometer-panel">
            <label class="info-label" for="withoutgrouping">{{ 'TRANSLATE.TWO.POINTS.ODOMETER' | translate }}</label>
            <div class="odometer-row">
              <p-inputNumber class="odometer-input" [(ngModel)]="vinValidate.odometro" mode="decimal"
                inputId="withoutgrouping" (ngModelChange)="onOdometerChange($event)" [useGrouping]="true"
                [maxFractionDigits]="0" [locale]="'pt-BR'" maxlength="8"
                placeholder="{{ 'TRANSLATE.ODOMETER' | translate }}"></p-inputNumber>
              <span class="odometer-unit">{{ 'TRANSLATE.KM' | translate }}</span>
            </div>

            @if (odometerErrorKey) {
            <p-message class="client-data-message" severity="error" text="{{ odometerErrorKey | translate }}">
            </p-message>
            }
          </div>
        </article>
      </section>
    </div>

    <div class="button-position">
      <button id="btnReturn" class="undo-action-button return app-clean-button" type="button"
        (click)="buttonComeBack()">
        <i class="pi pi-arrow-left" aria-hidden="true"></i>
        <span class="undo-action-button-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>

      <app-cta-button [label]="'TRANSLATE.TOCHOOSE.PLAN'" icon="pi-check" [disabled]="disableStartNullWarranty"
        [successState]="isCtaSuccess" (buttonClick)="buttonNext()">
      </app-cta-button>
    </div>
    }
  </div>
</div>